import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiMenuAlt3, HiShoppingCart } from 'react-icons/hi';
import happy_hvid from '../images/happy-hvid.png';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleNav = () => {
    setNav(!nav);
    if(!nav) {
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.overflow = 'scroll'
    }
  };
  const navigate = useNavigate();

  return (
    <div className='absolute w-full flex justify-between p-4 items-center'>
      {/* <h1 className='text-white font-bold text-2xl z-20' style={{ visibility: 'hidden' }}>Happy outdoors</h1> */}
      <img alt='happy-hvid-logo' className="z-20" src={happy_hvid} onClick={() => navigate('/')} style={{height: '60px', cursor: 'pointer'}}/>
      <div className='flex items-center gap-4'>
        <HiShoppingCart onClick={() => navigate('/basket')} className='z-20 text-white cursor-pointer' size={25} />
        <HiMenuAlt3 onClick={handleNav} className='z-20 text-white cursor-pointer' size={25} />
      </div>
      <div
        className={
          nav
            ? 'ease-in duration-300 fixed text-gray-300 left-0 top-0 w-full h-screen bg-black/90 px-4 py-7 flex-col z-10'
            : 'absolute top-0 h-screen left-[-100%] ease-in duration-500 z-10'
        }
      >
        <ul className='flex flex-col fixed w-full h-full items-center justify-center'>
          <li className='font-bold text-3xl p-8'>
            <a href='/'>Home</a>
          </li>
          <li className='font-bold text-3xl p-8'>
            <a href='/shop'>Shop</a>
          </li>
          <li className='font-bold text-3xl p-8'>
            <a href="/basket">Basket</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
